import '../css/app.css';
import './bootstrap';
// Cache bust v2

import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';
import { createI18n } from 'vue-i18n';
import TheMask from 'vue-the-mask';
import VueLazyLoad from 'vue3-lazyload';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';

import dayjs from '@/plugins/dayjs';
import vmoney from '@/plugins/vmoney';

import { createPinia } from 'pinia';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

const pinia = createPinia();

createInertiaApp({
    title: (title) => `${title}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const { locale, translations, allTranslations } = props.initialPage.props;

        const i18n = createI18n({
            legacy: false,
            locale: locale || 'tr',
            fallbackLocale: 'en',
            messages: allTranslations ?? {
                // tercih edilen: iki dili birden hazır ver
                [locale || 'tr']: translations || {}, // en azından aktif dili locale altında sar
            },
        });

        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(pinia)
            .use(ZiggyVue)
            .use(TheMask)
            .use(dayjs)
            .use(vmoney)
            .use(VueLazyLoad)
            .use(i18n)
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});

console.warn = () => {};
